import type { IAugmentedJQuery, IServiceProvider } from "angular";
import jQuery from "jquery";
import { includes } from "lodash";
import type { IValidationService } from "./IValidationService";

export default [
    "aaFormExtensionsProvider",
    "irValidationServiceProvider",
    function validationConfig(
        aaFormExtensionsProvider: aa.IFormExtensionsProvider,
        validationServiceProvider: IServiceProvider,
    ) {
        // tslint:disable object-literal-sort-keys
        aaFormExtensionsProvider.validationMessages = {
            email: "{{'Validation.IsNotValidEmail' | translate : {propertyName: '{0}'} }}",
            max: "{{'Validation.ShouldBeMax' | translate : {propertyName: '{0}', constraint: '{1}'} }}",
            maxlength: "{{'Validation.ShouldHaveMaxLength' | translate : {propertyName: '{0}', constraint: '{1}'} }}",
            min: "{{'Validation.ShouldBeMin' | translate : {propertyName: '{0}', constraint: '{1}'} }}",
            minlength: "{{'Validation.ShouldHaveMinLength' | translate : {propertyName: '{0}', constraint: '{1}'} }}",
            number: "{{'Validation.ShouldBeNumeric' | translate : {propertyName: '{0}'} }}",
            required: "{{'Validation.IsRequired' | translate : {propertyName: '{0}'} }}",
            pattern: "{{'Validation.IsNotValid' | translate : {propertyName: '{0}'} }}",
            path: "{{'Validation.IsNotValidPath' | translate }}",
            url: "{{'Validation.IsNotValidUrl' | translate : {propertyName: '{0}'} }}",
            unique: "{{'Validation.IsNotUnique' | translate : {propertyName: '{0}'} }}",
            unknown: "{{'Validation.IsNotValid' | translate : {propertyName: '{0}'} }}",
            validationTitle: "{{'Validation.ValidationErrorTitle' | translate }}",
            moment: "{{'Validation.IsNotValid' | translate : {propertyName: '{0}'} }}",
        };

        // custom strategy to to handle validation message placement
        aaFormExtensionsProvider.defaultValMsgPlacementStrategy = "below-wrapped-element";
        (aaFormExtensionsProvider as any).valMsgPlacementStrategies = {
            "below-wrapped-element": (formFieldElement: IAugmentedJQuery, formName: string, formFieldName: string) => {
                const msgElement = jQuery(`<div aa-val-msg-for=${formName}.${formFieldName}></div>`);
                const role: string = formFieldElement.data("role");
                const combinedInputs = ["datepicker", "datetimepicker", "combobox"];

                if (includes(combinedInputs, role)) {
                    formFieldElement.parent().parent().parent().append(msgElement);
                } else {
                    formFieldElement.after(msgElement);
                }

                return msgElement;
            },
        };

        aaFormExtensionsProvider.defaultLabelStrategy = "ir-label";
        (aaFormExtensionsProvider as any).labelStrategies = {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            "ir-label": (element: IAugmentedJQuery, labelText: string, isRequired: boolean, $injector: any) => {
                const label = jQuery("<label>").attr("for", element[0].id).addClass("control-label").html(labelText);

                element.closest(".form-group").prepend(label);
            },
        };

        aaFormExtensionsProvider.valMsgForTemplate =
            '<div class="validation-errors" ng-show="showMessages">' +
            '<div class="validation-error ng-animate-disabled" ' +
            ' ng-repeat="msg in errorMessages | irUnique track by $index" ng-cloak>{{msg | irInterpolate}}</div>' +
            "</div>";
        let validationService: IValidationService;
        (aaFormExtensionsProvider as any).ajaxValidationErrorMappingStrategy = (response: any, availableForms: any) => {
            if (response.status !== 400 || !response.data.errors) {
                return response; // NOT bad request, a validation error or there aren't any errors to push
            }
            if (!validationService) {
                validationService = validationServiceProvider.$get();
            }

            validationService.showErrors(response.data.errors, availableForms);
            return undefined;
        };
    },
];
